import lottie from "lottie-web";
import { defineElement } from "@lordicon/element";
defineElement(lottie.loadAnimation);

const Loader = () => {

    return (
        <div className="py-4 text-center">
            <lord-icon
                src="./loader.json"
                trigger="loop"
                colors="primary:#405189,secondary:#0ab39c"
                style={{ width: "72px", height: "72px" }}
            />
            <div className="mt-4">
                <h5>Fetching data! Please wait, this may take a while.</h5>
            </div>
        </div>
    );
}

export default Loader;